export default [
    // costco
    'Cos37346',
    'cos24002000',
    'cos8376000',
    'cos10362000',
    'cos10470000',
    'cos24003000',
    'Cos37605',
    'cos15880000',
    'cos23535000',
    'cos23527000',
    'cos10258000',
    'cos10026000',
    'cos10259000',
    'cos17072000',
    'Cos37849',
    'Cos45298',
    // walgreens
    'wal7875000',
    'wal13424000',
    'wal13255000',
    'wal13399000',
    'wal13400000',
    'wal22952000',
    'wal24234000',
    'wal24386000',
    'wal24387000',
    'wal13126000',
    'wal21318000',
    'wal21332000',
    'wal21331000',
    'wal21327000',
    'wal21330000',
    'wal21333000',
    'wal21328000',
    'wal21329000',
    'wal21316000',
    'wal21317000',
    'wal21319000',
    'wal21315000',
    'wal21325000',
    'wal21323000',
    'wal10959000',
    'wal11852000',
    'med559000',
    'wal11904000',
    'wal15699000',
    'wal15701000',
    'wal15702000',
    'wal15703000',
    'wal15704000',
    'wal15707000',
    'wal11828000',
    'wal23534000',
    'wal23528000',
    'wal9757000',
    'cir567000',
    'dir563000',
    'sav558000',
    'wal25955000',
    'wal9891000',
    // golden 1
    'gol14276000',
    'gol14215000',
    'gol14277000',
    'gol14383000',
    'gol14384000',
    'gol14561000',
    'gol14639000',
    'gol16826000',
    'gol16827000',
    'gol16828000',
    'gol19186000',
    'gol19187000',
    'gol19514000',
    'gol21435000',
    'gol23225000',
    'gol23226000',
    'gol23227000',
    'gol23228000',
    'gol23229000',
    'gol24321000',
    'gol24322000',
    'gol24323000',
    'gol26391000',
    'gol26392000',
    'gol26393000',
    // testing
    'dis144340302',
    'dis144340302',
    'tes23592000',
    'pro21427000',
    'pro6491000',
    'pro21428000',
    'pro6493000',
    'pro21430000',
    'pro6492000',
    'fmg9427000',
    'pro10017000',
    'pro11452000',
    'pro11456000',
    'pro11464000',
    'pro11553000',
    'pro12565000',
    'pro12671000',
    'pro21427000',
    'pro21653000',
    'pro6476000',
    'pro6491000',
    'pro6496000',
    'pro6501000',
    'pro10018000',
    'pro11453000',
    'pro11457000',
    'pro11461000',
    'pro11465000',
    'pro11555000',
    'pro12677000',
    'pro18751000',
    'pro21430000',
    'pro21654000',
    'pro23682000',
    'pro23683000',
    'pro23684000',
    'pro23685000',
    'pro23949000',
    'pro6477000',
    'pro6492000',
    'pro6497000',
    'pro6502000',
    'sjp9428000',
    'pma9429000',
    'pro10019000',
    'pro11454000',
    'pro11458000',
    'pro11462000',
    'pro11466000',
    'pro11554000',
    'pro12568000',
    'pro12676000',
    'pro18753000',
    'pro21428000',
    'pro21655000',
    'pro23678000',
    'pro23679000',
    'pro23680000',
    'pro23681000',
    'pro23948000',
    'pro6478000',
    'pro6493000',
    'pro6498000',
    'pro6503000',
    'pro7969000',
];
